var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductAddImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 422,
    height: 393,
    viewBox: "0 0 422 393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-479 -2066)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(479 2066)",
    fill: "none",
    stroke: "#068ecf",
    strokeWidth: 2,
    strokeDasharray: 9
  }, /*#__PURE__*/React.createElement("rect", {
    width: 422,
    height: 393,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 420,
    height: 391,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(690 2281)",
    fill: "#068ecf",
    fontSize: 96,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.836,
    y: 0
  }, "+")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAddImagePlaceholder);
export default __webpack_public_path__ + "static/media/ProductAddImagePlaceholder.03dda8e52fe908cc6afad89d93dfea14.svg";
export { ForwardRef as ReactComponent };